import { PORTAL_PROXY_TOKEN } from '../settings';
import {
  type ApiMediaUploadResponseDto,
  type ApiMediaUploadSettings,
  type FieldValue,
  type JsmErrorResponseDto,
} from '../types';
import { JsmClient } from '../utilities';
import { mapJsmErrorResponseDtoToFormError } from './mapJsmErrorResponseDtoToFormError';

export const finishApiMediaUpload = async (
  apiMediaUploadSettings: ApiMediaUploadSettings,
  fileId: string,
): Promise<FieldValue> => {
  const jsmClient = new JsmClient(apiMediaUploadSettings.portalBaseUrl);
  const url = '/media/upload';

  // to avoid preflight request send this JSON data as plain/text
  // and send proxy token in Content-Language header - portal proxy will fix it
  const headers: any = {
    'Content-Type': 'text/plain',
    'Content-Language': PORTAL_PROXY_TOKEN,
  };
  // append XSRF token if exists
  if (apiMediaUploadSettings.xsrfToken) {
    headers['X-Xsrf-Token'] = apiMediaUploadSettings.xsrfToken;
  }

  try {
    const response = await jsmClient.post(
      url,
      { fileId },
      {
        // set credentials option to 'include' to pass 'atlassian.xsrf.token' cookie in the request;
        // the cookie is obtained in createApiMediaUploadCredentials call, but only if third-party cookies are allowed in the browser
        credentials: 'include',
        headers,
      },
    );
    return mapApiMediaUploadResponseDtoToFieldValue(response as ApiMediaUploadResponseDto);
  } catch (error: any) {
    console.error('finishApiMediaUpload: JSM error:', JSON.parse(JSON.stringify(error)));
    const jsmError = error.responseBody as JsmErrorResponseDto;
    throw mapJsmErrorResponseDtoToFormError(jsmError);
  }
};

const mapApiMediaUploadResponseDtoToFieldValue = (response: ApiMediaUploadResponseDto): FieldValue => {
  return response.attachmentId;
};
